// extracted by mini-css-extract-plugin
module.exports = {"delBtnWR":"DelCompanyBlock_delBtnWR__1KDXc","delBtn":"DelCompanyBlock_delBtn__20MDs"};